// extracted by mini-css-extract-plugin
export default {"results":"Picker_results__tTg4b"};